<body id="operation-summary">
  <div class="operation-summary-table-container">
    <table mat-table matSort [dataSource]="dataSource">
      <caption>
        Operations Summary
      </caption>
      <!-- Route -->
      <ng-container matColumnDef="route">
        <th
          class="route-header-hidden"
          mat-header-cell
          *matHeaderCellDef
          [attr.rowspan]="2"
          id="route-header"
        ></th>
        <td
          mat-cell
          *matCellDef="let summary"
          headers="route-header"
          class="left-data-column"
        >
          <a
            [routerLink]="getRouteDetailsLink(summary)"
            [queryParams]="{ date: selectedDate }"
            [state]="{
              data: routeDetails,
              selectedRoute: summary.route,
              selectedDate: selectedDate,
            }"
          >
            {{ summary.route }}
          </a>
        </td>
      </ng-container>

      <!-- Total Delivery Stops -->
      <ng-container matColumnDef="deliveryStops.total">
        <th
          mat-header-cell
          mat-sort-header
          (click)="
            sortTotalDeliveryStops = !sortTotalDeliveryStops;
            customSorting(
              ColumnIds.TOTAL_DELIVERY_STOPS,
              sortTotalDeliveryStops
            )
          "
          onkeypress="
            sortTotalDeliveryStops = !sortTotalDeliveryStops;
            customSorting(
              ColumnIds.TOTAL_DELIVERY_STOPS,
              sortTotalDeliveryStops,
            );
          "
          *matHeaderCellDef
          class="sub-columns"
          id="total-deliveryStops-headers"
        >
          <app-table-sorting-box
            [title]="HEADERS.Total"
            [width]="126"
            [sortAddedAsc]="sortTotalDeliveryStops"
            [rightAlign]="true"
          ></app-table-sorting-box>
        </th>
        <td
          mat-cell
          *matCellDef="let summary; let i = index"
          headers="total-deliveryStops-headers"
          class="right-data-column"
        >
          {{ summary.deliveryStops?.total }}
        </td>
      </ng-container>

      <!-- Completed Delivery Stops -->
      <ng-container matColumnDef="deliveryStops.completed">
        <th
          mat-header-cell
          mat-sort-header
          (click)="
            sortCompletedDeliveryStops = !sortCompletedDeliveryStops;
            customSorting(
              ColumnIds.COMPLETED_DELIVERY_STOPS,
              sortCompletedDeliveryStops
            )
          "
          onkeydown="
            sortCompletedDeliveryStops = !sortCompletedDeliveryStops;
            customSorting(
              ColumnIds.COMPLETED_DELIVERY_STOPS,
              sortCompletedDeliveryStops,
            );
          "
          *matHeaderCellDef
          class="sub-columns"
          id="completed-deliveryStops-headers"
        >
          <app-table-sorting-box
            [title]="HEADERS.Completed"
            [sortAddedAsc]="sortCompletedDeliveryStops"
            [rightAlign]="true"
          ></app-table-sorting-box>
        </th>
        <td
          mat-cell
          *matCellDef="let summary; let i = index"
          headers="completed-deliveryStops-headers"
          class="right-data-column"
        >
          {{ summary.deliveryStops?.completed }}
        </td>
      </ng-container>

      <!-- Pending Delivery Stops -->
      <ng-container matColumnDef="deliveryStops.pending">
        <th
          mat-header-cell
          mat-sort-header
          (click)="
            sortPendingDeliveryStops = !sortPendingDeliveryStops;
            customSorting(
              ColumnIds.PENDING_DELIVERY_STOPS,
              sortPendingDeliveryStops
            )
          "
          onkeypress="
            sortPendingDeliveryStops = !sortPendingDeliveryStops;
            customSorting(
              ColumnIds.PENDING_DELIVERY_STOPS,
              sortPendingDeliveryStops,
            );
          "
          *matHeaderCellDef
          class="sub-columns"
          id="pending-deliveryStops-headers"
        >
          <app-table-sorting-box
            [title]="HEADERS.Pending"
            [sortAddedAsc]="sortPendingDeliveryStops"
            [rightAlign]="true"
          ></app-table-sorting-box>
        </th>
        <td
          mat-cell
          *matCellDef="let summary; let i = index"
          headers="pending-deliveryStops-headers"
          class="right-data-column"
        >
          {{ summary.deliveryStops?.pending }}
        </td>
      </ng-container>

      <!-- Total Delivery Volume -->
      <ng-container matColumnDef="deliveryVolume.total">
        <th
          mat-header-cell
          mat-sort-header
          (click)="
            sortTotalDeliveryVolume = !sortTotalDeliveryVolume;
            customSorting(
              ColumnIds.TOTAL_DELIVERY_VOLUME,
              sortTotalDeliveryVolume
            )
          "
          onkeypress="
            sortTotalDeliveryVolume = !sortTotalDeliveryVolume;
            customSorting(
              ColumnIds.TOTAL_DELIVERY_VOLUME,
              sortTotalDeliveryVolume,
            );
          "
          *matHeaderCellDef
          class="sub-columns"
          id="total-delivery-volume-headers"
        >
          <app-table-sorting-box
            [title]="HEADERS.Total"
            [width]="126"
            [sortAddedAsc]="sortTotalDeliveryVolume"
            [rightAlign]="true"
          ></app-table-sorting-box>
        </th>
        <td
          mat-cell
          *matCellDef="let summary; let i = index"
          headers="total-delivery-volume-headers"
          class="right-data-column"
        >
          {{ summary.deliveryVolume?.total }}
        </td>
      </ng-container>

      <!-- Completed Delivery Volume -->
      <ng-container matColumnDef="deliveryVolume.completed">
        <th
          mat-header-cell
          mat-sort-header
          (click)="
            sortCompletedDeliveryVolume = !sortCompletedDeliveryVolume;
            customSorting(
              ColumnIds.COMPLETED_DELIVERY_VOLUME,
              sortCompletedDeliveryVolume
            )
          "
          onkeypress="
            sortCompletedDeliveryVolume = !sortCompletedDeliveryVolume;
            customSorting(
              ColumnIds.COMPLETED_DELIVERY_VOLUME,
              sortCompletedDeliveryVolume,
            );
          "
          *matHeaderCellDef
          class="sub-columns"
          id="completed-delivery-volume-headers"
        >
          <app-table-sorting-box
            [title]="HEADERS.Completed"
            [sortAddedAsc]="sortCompletedDeliveryVolume"
            [rightAlign]="true"
          ></app-table-sorting-box>
        </th>
        <td
          mat-cell
          *matCellDef="let summary; let i = index"
          headers="completed-delivery-volume-headers"
          class="right-data-column"
        >
          {{ summary.deliveryVolume?.completed }}
        </td>
      </ng-container>

      <!-- Pending Delivery Volume -->
      <ng-container matColumnDef="deliveryVolume.pending">
        <th
          mat-header-cell
          mat-sort-header
          (click)="
            sortPendingDeliveryVolume = !sortPendingDeliveryVolume;
            customSorting(
              ColumnIds.PENDING_DELIVERY_VOLUME,
              sortPendingDeliveryVolume
            )
          "
          onkeypress="
            sortPendingDeliveryVolume = !sortPendingDeliveryVolume;
            customSorting(
              ColumnIds.PENDING_DELIVERY_VOLUME,
              sortPendingDeliveryVolume,
            );
          "
          *matHeaderCellDef
          class="sub-columns"
          id="pending-delivery-volume-headers"
        >
          <app-table-sorting-box
            [title]="HEADERS.Pending"
            [sortAddedAsc]="sortPendingDeliveryVolume"
            [rightAlign]="true"
          ></app-table-sorting-box>
        </th>
        <td
          mat-cell
          *matCellDef="let summary; let i = index"
          headers="pending-delivery-volume-headers"
          class="right-data-column"
        >
          {{ summary.deliveryVolume?.pending }}
        </td>
      </ng-container>

      <!-- Total Pickup Stops -->
      <ng-container matColumnDef="pickupStops.total">
        <th
          mat-header-cell
          mat-sort-header
          (click)="
            sortTotalPickupStops = !sortTotalPickupStops;
            customSorting(ColumnIds.TOTAL_PICKUP_STOPS, sortTotalPickupStops)
          "
          onkeypress="
            sortTotalPickupStops = !sortTotalPickupStops;
            customSorting(ColumnIds.TOTAL_PICKUP_STOPS, sortTotalPickupStops);
          "
          *matHeaderCellDef
          class="sub-columns"
          id="total-pickup-stops-headers"
        >
          <app-table-sorting-box
            [title]="HEADERS.Total"
            [width]="126"
            [sortAddedAsc]="sortTotalPickupStops"
            [rightAlign]="true"
          ></app-table-sorting-box>
        </th>
        <td
          mat-cell
          *matCellDef="let summary; let i = index"
          headers="total-pickup-stops-headers"
          class="right-data-column"
        >
          {{ summary.pickupStops?.total }}
        </td>
      </ng-container>

      <!-- Completed Pickup Stops -->
      <ng-container matColumnDef="pickupStops.completed">
        <th
          mat-header-cell
          mat-sort-header
          (click)="
            sortCompletedPickupStops = !sortCompletedPickupStops;
            customSorting(
              ColumnIds.COMPLETED_PICKUP_STOPS,
              sortCompletedPickupStops
            )
          "
          onkeypress="
            sortCompletedPickupStops = !sortCompletedPickupStops;
            customSorting(
              ColumnIds.COMPLETED_PICKUP_STOPS,
              sortCompletedPickupStops,
            );
          "
          *matHeaderCellDef
          class="sub-columns"
          id="completed-pickup-stops-headers"
        >
          <app-table-sorting-box
            [title]="HEADERS.Completed"
            [sortAddedAsc]="sortCompletedPickupStops"
            [rightAlign]="true"
          ></app-table-sorting-box>
        </th>
        <td
          mat-cell
          *matCellDef="let summary; let i = index"
          headers="completed-pickup-stops-headers"
          class="right-data-column"
        >
          {{ summary.pickupStops?.completed }}
        </td>
      </ng-container>

      <!-- Pending Pickup Stops -->
      <ng-container matColumnDef="pickupStops.pending">
        <th
          mat-header-cell
          mat-sort-header
          (click)="
            sortPendingPickupStops = !sortPendingPickupStops;
            customSorting(
              ColumnIds.PENDING_PICKUP_STOPS,
              sortPendingPickupStops
            )
          "
          onkeypress="
            sortPendingPickupStops = !sortPendingPickupStops;
            customSorting(
              ColumnIds.PENDING_PICKUP_STOPS,
              sortPendingPickupStops,
            );
          "
          *matHeaderCellDef
          class="sub-columns"
          id="pending-pickup-stops-headers"
        >
          <app-table-sorting-box
            [title]="HEADERS.Pending"
            [sortAddedAsc]="sortPendingPickupStops"
            [rightAlign]="true"
          ></app-table-sorting-box>
        </th>
        <td
          mat-cell
          *matCellDef="let summary; let i = index"
          headers="pending-pickup-stops-headers"
          class="right-data-column"
        >
          {{ summary.pickupStops?.pending }}
        </td>
      </ng-container>

      <!-- Completed Pickup Volume -->
      <ng-container matColumnDef="pickupVolume.completed">
        <th
          mat-header-cell
          mat-sort-header
          (click)="
            sortCompletedPickupVolume = !sortCompletedPickupVolume;
            customSorting(
              ColumnIds.COMPLETED_PICKUP_VOLUME,
              sortCompletedPickupVolume
            )
          "
          onkeypress="
            sortCompletedPickupVolume = !sortCompletedPickupVolume;
            customSorting(
              ColumnIds.COMPLETED_PICKUP_VOLUME,
              sortCompletedPickupVolume,
            );
          "
          *matHeaderCellDef
          class="sub-columns"
          id="completed-pickup-volume-headers"
        >
          <app-table-sorting-box
            [title]="HEADERS.Completed"
            [width]="160"
            [sortAddedAsc]="sortCompletedPickupVolume"
            [rightAlign]="true"
          ></app-table-sorting-box>
        </th>
        <td
          mat-cell
          *matCellDef="let summary; let i = index"
          headers="completed-pickup-volume-headers"
          class="right-data-column"
        >
          {{ summary.pickupVolume?.completed ?? 0 }}
        </td>
      </ng-container>

      <!-- Completion Stops -->
      <ng-container matColumnDef="routeCompletionStatus.stops">
        <th
          mat-header-cell
          mat-sort-header
          (click)="
            sortRouteCompletionStops = !sortRouteCompletionStops;
            customSorting(
              ColumnIds.ROUTE_COMPLETION_STOPS,
              sortRouteCompletionStops
            )
          "
          onkeypress="
            sortRouteCompletionStops = !sortRouteCompletionStops;
            customSorting(
              ColumnIds.ROUTE_COMPLETION_STOPS,
              sortRouteCompletionStops,
            );
          "
          *matHeaderCellDef
          class="sub-columns"
          id="completion-stops-headers"
        >
          <app-table-sorting-box
            [title]="HEADERS.Stops"
            [width]="127"
            [sortAddedAsc]="sortRouteCompletionStops"
            [rightAlign]="true"
          ></app-table-sorting-box>
        </th>
        <td
          mat-cell
          *matCellDef="let summary; let i = index"
          headers="completion-stops-headers"
          class="right-data-column"
        >
          {{ summary.routeCompletionStatus?.stops ?? 0 }}%
        </td>
      </ng-container>

      <!-- Completion Volume -->
      <ng-container matColumnDef="routeCompletionStatus.volume">
        <th
          mat-header-cell
          mat-sort-header
          (click)="
            sortRouteCompletionVolume = !sortRouteCompletionVolume;
            customSorting(
              ColumnIds.ROUTE_COMPLETION_VOLUME,
              sortRouteCompletionVolume
            )
          "
          onkeypress="
            sortRouteCompletionVolume = !sortRouteCompletionVolume;
            customSorting(
              ColumnIds.ROUTE_COMPLETION_VOLUME,
              sortRouteCompletionVolume,
            );
          "
          *matHeaderCellDef
          class="sub-columns"
          id="completion-volume-headers"
        >
          <app-table-sorting-box
            [title]="HEADERS.Volume"
            [sortAddedAsc]="sortRouteCompletionVolume"
            [rightAlign]="true"
          ></app-table-sorting-box>
        </th>
        <td
          mat-cell
          *matCellDef="let summary; let i = index"
          headers="completion-volume-headers"
          class="right-data-column"
        >
          {{ summary.routeCompletionStatus?.volume ?? 0 }}%
        </td>
      </ng-container>

      <!-- Main headers -->
      <!-- Route -->
      <ng-container matColumnDef="header-row-first-group">
        <th
          mat-header-cell
          *matHeaderCellDef
          [attr.rowspan]="2"
          id="route-headers"
        >
          <app-table-search-component
            class="header-row-first-group route-table-header"
            [columnName]="HEADERS.Route"
            [control]="routeData.formControl"
            [maxLength]="3"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>
        <td mat-cell *matCellDef="let route" headers="route-headers">
          {{ route.routeID }}
        </td>
      </ng-container>

      <!-- Delivery Stops -->
      <ng-container matColumnDef="header-row-sec-group">
        <th
          mat-header-cell
          *matHeaderCellDef
          [attr.colspan]="3"
          id="deliveryStops-headers"
        >
          <ion-row class="column-headers">
            {{ HEADERS.Delivery_stops }}
          </ion-row>
        </th>
      </ng-container>

      <!-- Delivery Volume -->
      <ng-container matColumnDef="header-row-third-group">
        <th
          mat-header-cell
          *matHeaderCellDef
          [attr.colspan]="3"
          id="deliveryVolume-headers"
        >
          <ion-row class="column-headers">
            {{ HEADERS.Delivery_volume }}
          </ion-row>
        </th>
      </ng-container>

      <!-- Pickup Stops -->
      <ng-container matColumnDef="header-row-forth-group">
        <th
          mat-header-cell
          *matHeaderCellDef
          [attr.colspan]="3"
          id="pickupStops-headers"
        >
          <ion-row class="column-headers">{{ HEADERS.Pickup_stops }}</ion-row>
        </th>
      </ng-container>

      <!-- Pickup Volume -->
      <ng-container matColumnDef="header-row-fifth-group">
        <th
          mat-header-cell
          *matHeaderCellDef
          [attr.colspan]="1"
          id="pickupVolume-headers"
        >
          <ion-row class="column-headers">
            {{ HEADERS.Pickup_volume }}
          </ion-row>
        </th>
      </ng-container>

      <!-- Route Completion Status -->
      <ng-container matColumnDef="header-row-sixth-group">
        <th
          mat-header-cell
          *matHeaderCellDef
          [attr.colspan]="2"
          class="final-row"
          id="routeCompletionStatus-headers"
        >
          <ion-row class="column-headers">
            {{ HEADERS.Route_completion_status }}
          </ion-row>
        </th>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="
          [
            'header-row-first-group',
            'header-row-sec-group',
            'header-row-third-group',
            'header-row-forth-group',
            'header-row-fifth-group',
            'header-row-sixth-group',
          ];
          sticky: true
        "
      ></tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row no-results-found" *matNoDataRow>
        <td class="mat-cell no-border" [attr.colspan]="displayedColumns.length">
          <app-no-results-found></app-no-results-found>
        </td>
      </tr>
    </table>
  </div>
  <app-table-pagination [datasource]="dataSource"></app-table-pagination>
</body>
